module.exports = __webpack_public_path__ + "img/ME.c68c9281.svg";